import LoadSpinner from './component';

export default LoadSpinner;
